module.exports = __webpack_public_path__ + "images/img_3_1-2b6485ff15.png";